(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Every instance, not the first. This was a single document.querySelector,
     so a second copy of the block anywhere on the page was never animated —
     and neither was the original once the theme editor re-rendered it.

     The flag makes a rescan free: an already-wired section is skipped, so
     this can be called as often as needed without stacking duplicate
     ScrollTriggers on the same element. */
  function init(section) {
    if (!section || section.dataset.lsInit) return;

    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST || reduce) return;

    section.dataset.lsInit = '1';

    gsap.registerPlugin(ST);
    if (window.SplitText) { try { gsap.registerPlugin(window.SplitText); } catch (e) {} }

    var heading = section.querySelector('[data-story-heading]');
    var para = section.querySelector('[data-story-text]');
    var figure = section.querySelector('[data-story-figure]');
    var media = section.querySelector('[data-story-media]');
    var SplitText = window.SplitText;

    section.classList.add('ls-ready');

    if (media && figure) {
      gsap.fromTo(media, { scale: 1.14 }, {
        scale: 1, ease: 'none',
        scrollTrigger: { trigger: figure, start: 'top bottom', end: 'bottom top', scrub: 0.6 }
      });
    }

    if (heading) {
      if (SplitText) {
        var hs = new SplitText(heading, { type: 'words', wordsClass: 'ls__hword' });
        gsap.set(hs.words, { yPercent: 120, opacity: 0 });
        gsap.to(hs.words, {
          yPercent: 0, opacity: 1, duration: 0.9, ease: 'power3.out', stagger: 0.06,
          scrollTrigger: { trigger: heading, start: 'top 85%' }
        });
      } else {
        gsap.from(heading, {
          y: 40, opacity: 0, duration: 1, ease: 'power3.out',
          scrollTrigger: { trigger: heading, start: 'top 85%' }
        });
      }
    }

    if (para) {
      if (SplitText) {
        var ps = new SplitText(para, { type: 'words', wordsClass: 'ls__word' });
        gsap.set(ps.words, { color: 'rgba(242, 235, 221, 0.24)' });
        gsap.to(ps.words, {
          color: '#f5f0e7', ease: 'none', stagger: { each: 0.5 },
          scrollTrigger: { trigger: figure, start: 'top 62%', end: 'bottom 56%', scrub: 0.4 }
        });
      } else {
        para.style.color = 'var(--ls-ink)';
      }
    }
  }

  function initAll(scope) {
    var els = (scope || document).querySelectorAll('[data-luxe-story]');
    if (!els.length) return;
    for (var i = 0; i < els.length; i++) init(els[i]);
    // once per pass rather than once per section — every trigger above is
    // measured against the same page
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  }

  function whenReady() {
    // fonts change the measured height of every split line, so the triggers
    // have to be built after they land
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { initAll(); });
    else initAll();
  }

  if (document.readyState !== 'loading') whenReady();
  else document.addEventListener('DOMContentLoaded', whenReady);

  // the editor rebuilds a section on every change — the fresh markup is a new
  // element, so the flag is gone with the old one and this wires it up again
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
